import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-138">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-139"></div>

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-141">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-142">
            📚 Mega Pack Industrialización de Alimentos en el Aula
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-143">
            Todo tu año de Tecnología de Alimentos{' '}
            <span className="text-gold-gradient" data-id="element-144">resuelto en una tarde.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[260px] sm:max-w-md md:max-w-xl mb-4 sm:mb-6" data-id="element-145">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-146"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gvwPBPwpa8URQxnSfXpJ7s/Diseno_sin_titulo_(27).png" alt="Mega Pack Industrialización de Alimentos en el Aula" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-147" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-148">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-149">
            El sistema completo para planificar, enseñar y evaluar — listo para
            usar desde hoy.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-150">
            <Button href="#pricing" className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-151">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-152">
            <div className="flex items-center gap-1.5" data-id="element-153">
              <CheckCircle size={14} className="text-gold" data-id="element-154" />
              <span data-id="element-155">5 tomos premium</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-156">
              <CheckCircle size={14} className="text-gold" data-id="element-157" />
              <span data-id="element-158">4 bonos estratégicos</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-159">
              <CheckCircle size={14} className="text-gold" data-id="element-160" />
              <span data-id="element-161">Acceso inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}